import { render, staticRenderFns } from "./resumen.vue?vue&type=template&id=8fe43f8e&scoped=true&"
import script from "./resumen.vue?vue&type=script&lang=ts&"
export * from "./resumen.vue?vue&type=script&lang=ts&"
import style0 from "./resumen.vue?vue&type=style&index=0&id=8fe43f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe43f8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow})
